import { makeObservable, observable } from "mobx";
import { partnerController } from "../api/controllers/partner";
import { RootStore } from "./index";
import { TicketConfig } from "../models/partnerResponse";

export class PartnerStore {
  isPinRequiredForBalanceChange = false;
  isPinRequiredForPayout = false;
  maxPayout = 0;
  businessUnitId: number | null = null;
  betshopId: number | null = null;
  partnerBusiness = {};

  ticketConfig: TicketConfig = {} as TicketConfig;

  constructor(rootStore?: RootStore) {
    makeObservable(this, {
      isPinRequiredForBalanceChange: observable,
      partnerBusiness: observable,
    });
  }

  public async getPartnerBusiness(): Promise<void> {
    const data = await partnerController.getPartnerBusiness();

    if (data) {
      this.businessUnitId = data.id;
      this.betshopId = data.betshopId;
      this.maxPayout = data.maxPayout;
      this.ticketConfig = data.ticketConfig;
      this.isPinRequiredForPayout = data.requirePinForPayout;
      this.isPinRequiredForBalanceChange = data.isPinRequiredForBalanceChange;
    }
  }
}
